<div class="carousel-item-wrapper">
    <ng-content></ng-content>
</div>
